import React, { useState, useEffect } from 'react'
import { bool, string } from 'prop-types'
import classNames from 'classnames'

import Button from 'components/atoms/Button'
import ShareSvg from 'components/atoms/SVGIcons/Share'
import Toast from 'components/atoms/Toast'

import isNavigatorAvailable from 'utils/isNavigatorAvailable'
import copyClipboard from 'utils/copyClipboard'

const ShareButton = ({ title, shareText, forNavbar }) => {
  const className = classNames(
    'share-btn m-y-md m-x-sm',
    {
      'share-btn--for-navbar': forNavbar,
    },
  )
  const [isToastVisible, setIsToastVisible] = useState(false)
  const toggleToast = () => {
    setIsToastVisible(!isToastVisible)
  }
  const shareLink = () => {
    const successCb = () => {
      toggleToast()
    }

    if ((isNavigatorAvailable() && navigator.share !== undefined)) {
      navigator.share({
        title,
        text: shareText,
        url: window.location.href,
      })
      // eslint-disable-next-line no-console
      .then(() => console.log('Link has been copied succesfuly!'))
      // eslint-disable-next-line no-console
      .catch(error => console.log('Error sharing', error))
    } else {
      copyClipboard({
        text: window.location.href,
        onSuccess: successCb,
      })
    }
  }

  useEffect(() => {
    if (isToastVisible) {
      setTimeout(toggleToast, 3000)
    }
  }, [isToastVisible])

  return (
    <>
      <Button
        component="button"
        className={className}
        variant="solid"
        onClick={shareLink}
      >
        <div className="share-btn__content">
          <ShareSvg fill="#7d92a9" />
          <span className="share-btn__text">Bagikan</span>
        </div>
        <style jsx global>
          {`
            .share-btn {
              z-index: 1;
              padding: 4px;
              border-radius: 4px;
              padding: 8px 8px;
              border: solid 1px #A3B4CA;

              &--for-navbar {
                padding: 0;
                border: none;
                .share-btn__content {
                  height: 100%;
                }
                svg {
                  width: 20px !important;
                  height: 17px !important;
                }
              }

              &__content {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                svg {
                  width: 24px;
                  height: 24px;
                }
              }

              &__text {
                display: none;
                @media screen and (min-width: 768px) {
                  display: inline;
                  margin-left: 8px;
                  color: #485c77;
                  font-weight: bold;
                }
              }

              @media screen and (min-width: 768px) {
                .share-btn__content {
                  svg {
                    margin-left: auto;
                    margin-right: auto;
                  }
                }
              }
            }
          `}
        </style>
      </Button>
      <Toast text="Link has been copied succesfuly!" isVisible={isToastVisible} bottom={80}/>
    </>
  )
}

ShareButton.propTypes = {
  title: string,
  shareText: string,
  forNavbar: bool,
}

export default ShareButton
